<div class="container-fluid">
    <div class="row m-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row pt-3 pb-3">
        <div class="col">
            <h2>Register Reader</h2>
        </div>
    </div>
    <form class="mb-2" [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="label" name="label" placeholder="Name"
                        formControlName="label">
                    <mat-error *ngIf="form.get('label').errors?.required">Name is required</mat-error>
                    <mat-error *ngIf="form.get('label').errors?.validationErrors">
                        {{ form.get("label").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="registrationCode" name="registrationCode" placeholder="Registration Code (candle-finish-tree)"
                        formControlName="registrationCode">
                    <mat-error *ngIf="form.get('registrationCode').errors?.required">Registration Code is required</mat-error>
                    <mat-error *ngIf="form.get('registrationCode').errors?.validationErrors">
                        {{ form.get("registrationCode").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <button mat-raised-button class="button-spacing" [disabled]="isLoading" type="submit">
                    Save
                </button>
            </div>
            <div class="col">
                <button type="button" mat-raised-button (click)="dialogRef.close({status: 'cancel', message: 'Cancelled reader creation'})" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </div>
    </form>
</div>